import {
  Button,
  Dialog,
  FormControlLabel,
  IconButton,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getSDocs, insertSDocs } from "../../../../server/server";
import { FaTrash } from "react-icons/fa";
import { useSearchParams } from "react-router-dom";
import { notif } from "../../../utils/util";
import RadioButtonGroup from "../../../../common/RadioButton";

function StrategicDocsModal({ register, onClose, open }: any) {
  const [searchParams] = useSearchParams();

  const [toggleState, setToggleState] = useState(null);
  const [docNames, setDocNames] = useState<string[]>([]);

  const fetchData = async () => {
    const resp = await getSDocs(register.natMeasureId);

    if (resp?.status === 200) {
      setToggleState(resp?.data?.show ?? null);
      setDocNames(resp?.data?.names ?? [""]);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleAddDoc = () => {
    setDocNames((prevDocs: string[]) => [...prevDocs, ""]);
  };

  const handleDeleteDoc = (index: number) => {
    setDocNames((prevDocs) => {
      if (index === 0) return prevDocs;
      const newDocs = [...prevDocs];
      newDocs.splice(index, 1);
      return newDocs.length === 0 ? [""] : newDocs;
    });
  };

  const handleDocNameChange = (event: any, index: number) => {
    setDocNames((prevDocs) => {
      const newDocs = [...prevDocs];
      newDocs[index] = event.target.value;
      return newDocs;
    });
  };

  const handleSave = async () => {
    const resp = await insertSDocs({
      show: toggleState,
      names: docNames,
      nationalMeasure: { id: register.id },
    });

    if (resp?.status === 201) {
      notif(
        `Веза успешно ${toggleState === null ? "додата" : "ажурирана"}`,
        "success"
      );
      onClose();
    } else {
      notif("Грешка при чувању везе са стратешким документом", "error");
    }
  };

  const isAddDisabled =
    Array.isArray(docNames) &&
    docNames.length > 0 &&
    (docNames[docNames.length - 1] ?? "").trim() === "";

  const requiresNames = toggleState === true || toggleState === null;
  const isSaveDisabled =
    requiresNames &&
    (!Array.isArray(docNames) ||
      docNames.length === 0 ||
      docNames.some((n) => (n ?? "").trim() === ""));

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <div className="p-4 w-full flex flex-col h-full overflow-y-auto justify-between">
        <div>
          <p className="text-[#04438b] text-2xl font-bold">
            Да ли постоји веза са стратешким документом?
          </p>
          {/* <FormControlLabel
            sx={{ marginLeft: "0px" }}
            control={
              <RadioButtonGroup
                state={toggleState}
                setState={setToggleState}
                isError={false}
                setIsError={() => 1}
              />
            }
            label=""
          /> */}

          <div>
            {docNames?.map((name, index) => {
              return (
                <div key={index} className="flex items-center my-2 w-full pt-2">
                  <TextField
                    label="Назив преговарачког документа"
                    variant="outlined"
                    value={!!name ? name : "Нема документа"}
                    multiline
                    minRows={1}
                    sx={{
                      width: "100%",
                      paddingRight: 2,
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "black",
                        opacity: 1,
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "black",
                      },
                    }}
                    onChange={(e) => handleDocNameChange(e, index)}
                    inputProps={{
                      style: {
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      },
                    }}
                    disabled
                  />
                  {/* <IconButton
                    onClick={() => handleDeleteDoc(index)}
                    className={`${
                      index === 0 ? "invisible" : ""
                    } text-gray-500 rounded-full w-[40px] h-[40px]`}
                    aria-hidden={index === 0}
                    title={
                      index === 0 ? "Прво поље не може да се обрише" : "Обриши"
                    }
                  >
                    <FaTrash />
                  </IconButton> */}
                </div>
              );
            })}
            {/* <Button
                color="primary"
                onClick={handleAddDoc}
                disabled={isAddDisabled}
              >
                Додај
              </Button> */}
          </div>
        </div>
        <div className="flex flex-row justify-end items-center w-full mt-6">
          <div
            className="border border-[#81848f] hover:bg-[#81848f] hover:text-white cursor-pointer flex items-center justify-center border-redError text-redError text-base font-semibold rounded-lg w-[250px] h-[55px]"
            onClick={() => onClose()}
          >
            Затвори
          </div>
          {/* <div
            className={`bg-darkBlue flex items-center justify-center text-white text-base font-semibold rounded-lg w-[250px] h-[55px] ${
              isSaveDisabled
                ? "opacity-50 cursor-not-allowed"
                : "hover:opacity-90 cursor-pointer"
            }`}
            onClick={() => {
              if (!isSaveDisabled) handleSave();
            }}
          >
            Сачувај
          </div> */}
        </div>
      </div>
    </Dialog>
  );
}

export default StrategicDocsModal;
